const getAppStoreId = () => {
  return process.env.REACT_APP_MOBILE_APP_STORE_ID;
};

const getGooglePlayUrl = () => {
  return process.env.REACT_APP_MOBILE_GOOGLE_PLAY_URL;
};

export default { getAppStoreId, getGooglePlayUrl };
